import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "rgba(255, 255, 255)",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'TwButton',
  props: {
		loading: {
			type: Boolean,
			default: false
		},
		rounded: {
			type: Boolean,
			default: false
		} 
	},
  setup(__props) {

// eslint-disable-next-line
    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["button", { 'rounded-full': __props.rounded }])
  }, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["btn-icon", {'mx-0': !_ctx.$slots.default}]),
          "aria-hidden": "true"
        }, [
          _renderSlot(_ctx.$slots, "icon")
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default && !__props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default && __props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.$slots.icon_right)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass(["btn-icon btn-icon-right", {'mx-0': !_ctx.$slots.default}]),
          "aria-hidden": "true"
        }, [
          _renderSlot(_ctx.$slots, "icon_right")
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})